import $axios from './index'
let api = {}
let options = {
    commonPath: '/potter'
}
let apiMap = {
    insertword: {
        url: '/insertword',
        params: ['word']
    },
    allwords: {
        url: '/allwords'
    },
    deleteword: {
        url: '/deleteword',
        params: ['word']
    },
}

$axios.registerApi(apiMap, options, api)
export default api
